export default __webpack_public_path__ + "static/media/clock-gray.a7b57af8.svg";